import { useSelector } from "react-redux";
import { getToken } from "../../../common/utils/tokenUtils";
import LoginPage from "../../MainPage/LoginPage";

const ProtectedRoute = ({ children, redirectTo = "/admin", requiredRole }) => {
  const login = useSelector((state) => state.login);
  const roleState = requiredRole && login[requiredRole] ? login[requiredRole] : { user: null, isLoggedIn: false };
  const { isLoggedIn, user } = roleState;
  const token = requiredRole ? getToken(requiredRole) : null;

  if (!requiredRole || !isLoggedIn || !user || !token) {
    return <LoginPage />;
  }

  return children;
};

export default ProtectedRoute;

